<template>
    <div class="container pt-2 text-center team" id="team">
        <div class="row">
            <div class="col-md-12 mx-md-auto text-uppercase text-center">
                <h2 class="font-weight-normal text-9 mb-3 pb-5 pt-2">Team</h2>    
            </div>
        </div>
        <div class="row pb-5">
            <div class="col-sm-6 col-lg-3 mb-4 mb-lg-0 appear-animation animated fadeInRightShorter appear-animation-visible" data-appear-animation="fadeInRightShorter" style="animation-delay: 100ms;" v-for="member in team" :key="member.id">
                <span class="thumb-info thumb-info-hide-wrapper-bg">
                    <span class="thumb-info-wrapper">
                        <img :src="member.image_url" class="img-fluid" alt="">
                        <span class="thumb-info-title">
                            <span class="thumb-info-inner">{{ member.first_name }} {{ member.last_name }}</span>
                        </span>
                    </span>
                </span>
            </div>
        
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    name: 'TeamList',
    data(){
        return{
            team: '',
            teamList: '',
        }
    }, 
    methods:{
        getName(){
            axios.get(process.env.VUE_APP_BASE_URL+'/codedive/items/team')
                .then(response => {
                    this.team = response.data.data;
                })
                .then(response => {
                    for(let i = 0; i < this.team.length;i++){
                        this.teamList += this.team[i].image +','
                    }
                })
                .then(response => {
                    axios.get(process.env.VUE_APP_BASE_URL+'/codedive/files?filter[id][in]='+this.teamList)
                    .then(response => {
                        for(let i = 0; i < this.team.length;i++){
                            this.team[i].image_url = response.data.data[i].data.full_url
                        } 
                    })
                })
        },
        slug: function(str) {
            str = str.replace(/^\s+|\s+$/g, ''); // trim
            str = str.toLowerCase();
        
            // remove accents, swap ñ for n, etc
            var from = "àáäâąèéëêęìíïîłńśźżòóöôùúüûñç·/_,:;";
            var to   = "aaaaaeeeeeiiiilnszzoooouuuunc------";
            for (var i=0, l=from.length ; i<l ; i++) {
                str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
            }

            str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
                .replace(/\s+/g, '-') // collapse whitespace and replace by -
                .replace(/-+/g, '-'); // collapse dashes

            return str;
        },
    },
    watch: {
        team: function(newValue, oldValue) {
            
        }
    },
    beforeMount(){
        this.getName();
    },
}
</script>

<style lang="scss">
    @import '@/assets/sass/variables.scss';
    @import '@/assets/sass/team.scss';  
</style>